class PaginatedList extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.getAttribute("data-section-id");
    this.itemClass = this.getAttribute("data-item-class");
    this.wrapperClass = this.getAttribute("data-wrapper-class");

    this.loading = false;
    this.currentPage = parseInt(this.getAttribute("data-paginate-page"));
    this.numPages = parseInt(this.getAttribute("data-paginate-pages"));

    this.listWrapper = (this.wrapperClass) ? this.querySelector(this.wrapperClass) : null;

    this.init();
  }

  init() {
    document.addEventListener("scroll", this.scrollHandler.bind(this));

    this.scrollHandler();
  }

  isLastPage() {
    return this.currentPage >= this.numPages;
  }

  setLoading(_loading) {
    this.loading = _loading;
    if (_loading) {
      this.classList.add("loading");
    } else {
      this.classList.remove("loading");
    }
  }

  scrollHandler(e) {
    if(!this.listWrapper) return;

    const listRect = this.listWrapper.getBoundingClientRect();

    if(!listRect) return;
    const loadMore = listRect.height - window.innerHeight + listRect.top < 0;

    if (loadMore && !this.loading && !this.isLastPage()) {
      this.setLoading(true);

      let searchParams = new URLSearchParams(location.search);
      if (!searchParams.has("sections")) {
        searchParams.append("sections", this.sectionId);
      }
      if (!searchParams.has("page")) {
        searchParams.append("page", this.currentPage + 1);
      } else {
        searchParams.set("page", this.currentPage + 1);
      }
      const urlParams = searchParams.toString();
      const url = `${location.pathname}?${urlParams}`;

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            return null;
          }
        })
        .then((responseJson) => {
          if (responseJson) {
            this.setLoading(false);
            this.currentPage++;

            // const newUrl = new URL(location);
            // newUrl.searchParams.set("page", this.currentPage);
            // history.pushState({}, "", newUrl);

            this.populateItems(responseJson[this.sectionId]);
          }
        });
    }
  }

  populateItems(sectionHtml) {
    const parser = new DOMParser();
    const section = parser.parseFromString(sectionHtml, "text/html");

    // The experiment variant is returned as inert content by section rendering.
    const variantContent = section.querySelector("template[data-purchase-grid-content]");
    const content = variantContent ? variantContent.content : section;
    const newElements = content.querySelectorAll(this.itemClass);
    for (let i = 0; i < newElements.length; i++) {
      const element = newElements[i];
      element.classList.remove("scroll-trigger");
      this.listWrapper.append(element);
    }
  }
}
customElements.define("paginated-list", PaginatedList);
